/**
 * Defines the icons that can be used.
 * Each key is an icon ID used throughout the codebase.
 *
 * @const
 */
// In practice, this defines a mapping from icon names to their file names under
// static/media/img/google_material_symbols. See https://fonts.google.com/icons?icon.set=Material+Symbols for the
// complete list of icons, where you can also download new icons. When adding new icons, use Material Symbols icons (as
// opposed to Material Icons icons), and use the Outlined style (as opposed to Rounded or Sharp). Download SVG icons
// instead of PNG icons. As for the settings:
// - Most of the time, use the default settings for icons: no fill, weight 400, grade 0, optical size 48px.
// - If you need filled versions of icons, enable fill, add the file here as usual (the file name should contain FILL1),
//   but append '_FILLED' to the key name so the non-filled version can be added easily later if needed.
// For icons that need to be usable offline, see getIconHtmlFromSvgData.
// Google Material Symbols are licensed under Apache License, Version 2.0.
export var ICON = {
    AIRPORT_SHUTTLE: 'airport_shuttle_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ALARM_OFF: 'alarm_off_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ALARM_ON: 'alarm_on_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    AMBULANCE: 'ambulance_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ANCHOR: 'anchor_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ARCHITECTURE: 'architecture_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ASSIGNMENT: 'assignment_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BATTERY_FULL_ALT: 'battery_full_alt_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BATTERY_HORIZ_000: 'battery_horiz_000_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BATTERY_HORIZ_050: 'battery_horiz_050_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BATTERY_HORIZ_075: 'battery_horiz_075_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BATTERY_LOW: 'battery_low_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BED: 'bed_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BEDTIME: 'bedtime_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BEDTIME_OFF: 'bedtime_off_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BLOCK: 'block_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    BUILD: 'build_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CAKE: 'cake_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CAMPING: 'camping_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CANCEL: 'cancel_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CAR_CRASH: 'car_crash_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CELEBRATION: 'celebration_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CHANGE_HISTORY_FILLED: 'change_history_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg',
    CHAT: 'chat_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CHAT_BUBBLE: 'chat_bubble_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CHECK: 'check_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CHECK_BOX: 'check_box_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CHECK_BOX_OUTLINE_BLANK: 'check_box_outline_blank_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CIRCLE_FILLED: 'circle_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg',
    CLOSE: 'close_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CODE: 'code_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    COFFEE: 'coffee_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    COMMUTE: 'commute_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    COMPUTER: 'computer_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CONSTRUCTION: 'construction_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CONTACT_EMERGENCY: 'contact_emergency_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    COOKIE: 'cookie_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CORONAVIRUS: 'coronavirus_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    CRISIS_ALERT: 'crisis_alert_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DENTISTRY: 'dentistry_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DEVICES: 'devices_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DEVICES_OFF: 'devices_off_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DINING: 'dining_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DIRECTIONS_BOAT: 'directions_boat_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DIRECTIONS_BUS: 'directions_bus_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DIRECTIONS_CAR: 'directions_car_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DIRECTIONS_RAILWAY: 'directions_railway_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DIRECTIONS_WALK: 'directions_walk_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DO_NOT_DISTURB_ON: 'do_not_disturb_on_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    DONE: 'done_FILL0_wght400_GRAD0_opsz48.svg',
    E911_EMERGENCY: 'e911_emergency_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    EAST: 'east_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ELECTRICAL_SERVICES: 'electrical_services_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    EMERGENCY: 'emergency_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ENGINEERING: 'engineering_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ENTERPRISE_OFF: 'enterprise_off_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ERROR_ICON: 'error_icon_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    EVENT_BUSY: 'event_busy_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    EXPAND_LESS: 'expand_less_FILL0_wght400_GRAD0_opsz48.svg',
    EXPAND_MORE: 'expand_more_FILL0_wght400_GRAD0_opsz48.svg',
    EXPLORE: 'explore_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    FACTORY: 'factory_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    FAVORITE_FILLED: 'favorite_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg',
    FIRE_TRUCK: 'fire_truck_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    FLASHLIGHT_ON: 'flashlight_on_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    FLIGHT: 'flight_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    FOGGY: 'foggy_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    FOOTPRINT: 'footprint_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    FORKLIFT: 'forklift_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    GROUPS: 'groups_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    HEALTH_CROSS_FILLED: 'health_cross_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg',
    HELICOPTER: 'helicopter_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    HELP_ICON: 'help_icon_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    HIKING: 'hiking_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    HOLIDAY_VILLAGE: 'holiday_village_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    HOME: 'home_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    HOME_WORK: 'home_work_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    HOURGLASS: 'hourglass_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    HOUSE: 'house_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    INDETERMINATE_CHECK_BOX: 'indeterminate_check_box_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    INFO: 'info_48dp_1F1F1F_FILL0_wght400_GRAD0_opsz48.svg',
    INFO_ICON: 'info_icon_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    LOCAL_FIRE_DEPARTMENT: 'local_fire_department_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    LOCAL_HOSPITAL: 'local_hospital_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    LOCAL_POLICE: 'local_police_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    LOGO_DEV: 'logo_dev_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    MAIL: 'mail_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    MAP: 'map_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    MEDICAL_SERVICES: 'medical_services_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    MEETING_ROOM: 'meeting_room_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    MOBILE: 'mobile_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    MODE_STANDBY: 'mode_standby_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    MONITORING: 'monitoring_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    NATURE: 'nature_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    NEAR_ME: 'near_me_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    NO_SOUND: 'no_sound_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    NORTH: 'north_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    NOTIFICATIONS: 'notifications_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    NOTIFICATIONS_PAUSED: 'notifications_paused_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    OUTBOUND: 'outbound_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PARK: 'park_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PARTLY_CLOUDY_DAY: 'partly_cloudy_day_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PERSON: 'person_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PERSON_ALERT: 'person_alert_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PERSON_CHECK: 'person_check_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PERSON_HEART: 'person_heart_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PERSON_OFF: 'person_off_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PERSONAL_INJURY: 'personal_injury_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PHONE_DISABLED: 'phone_disabled_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PHONE_ENABLED: 'phone_enabled_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PLUMBING: 'plumbing_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    POOL: 'pool_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PRESCRIPTIONS: 'prescriptions_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PUBLIC: 'public_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    PUBLIC_OFF: 'public_off_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    RAINY: 'rainy_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    RESTAURANT: 'restaurant_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ROAD: 'road_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    ROCKET: 'rocket_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SAILING: 'sailing_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SCHEDULE: 'schedule_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SCIENCE: 'science_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SEARCH: 'search_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SECURITY: 'security_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SENTIMENT_DISSATISFIED: 'sentiment_dissatisfied_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SENTIMENT_NEUTRAL: 'sentiment_neutral_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SENTIMENT_SATISFIED: 'sentiment_satisfied_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SEVERE_COLD: 'severe_cold_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SHOPPING_CART: 'shopping_cart_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SICK: 'sick_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SIGNAL_CELLULAR_0_BAR: 'signal_cellular_0_bar_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SIGNAL_CELLULAR_1_BAR: 'signal_cellular_1_bar_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SIGNAL_CELLULAR_2_BAR: 'signal_cellular_2_bar_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SIGNAL_CELLULAR_3_BAR: 'signal_cellular_3_bar_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SIGNAL_CELLULAR_4_BAR: 'signal_cellular_4_bar_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SIREN: 'siren_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SNOWING: 'snowing_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SOS: 'sos_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SOUTH: 'south_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SQUARE_FILLED: 'square_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg',
    STAR: 'star_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    STOP: 'stop_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SUNNY: 'sunny_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    SUPPORT_AGENT: 'support_agent_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    TARGET: 'target_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    THUMB_DOWN: 'thumb_down_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    THUMB_UP: 'thumb_up_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    THUNDERSTORM: 'thunderstorm_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    TRAVEL: 'travel_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    VITAL_SIGNS: 'vital_signs_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    WAREHOUSE: 'warehouse_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    WARNING_ICON: 'warning_icon_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    WATER: 'water_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    WEEKEND: 'weekend_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    WEST: 'west_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    WORK: 'work_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg',
    WORK_ALERT: 'work_alert_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg'
};